(() => {
  if (window.PhoenixReferenceReels) { window.PhoenixReferenceReels.scan(document); return; }
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const stop = video => { if (!video.paused) video.pause(); };
  const hydrate = video => {
    let changed = false;
    video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; delete source.dataset.src; changed = true; });
    if (changed) video.load();
  };
  function init(root) {
    if (instances.has(root) || typeof Swiper === 'undefined') return;
    const element = root.querySelector('.clone-artist-media-swiper');
    if (!element) return;
    const abort = new AbortController();
    const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: abort.signal });
    let frame = 0;
    let stoppedByUser = false;
    let previousVideo = null;
    let visible = false;
    let swiper;
    const videos = () => [...root.querySelectorAll('video')];
    const current = () => swiper?.slides[swiper.activeIndex]?.querySelector('video');
    const isVisible = video => {
      if (!video || document.hidden || !video.getClientRects().length) return false;
      const r = video.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && Math.min(r.bottom, innerHeight) - Math.max(r.top, 0) >= Math.min(r.height * .5, innerHeight * .5) && Math.min(r.right, innerWidth) - Math.max(r.left, 0) >= r.width * .8;
    };
    const labels = video => {
      const slide = video?.closest('.swiper-slide');
      const pause = slide?.querySelector('[data-reference-pause]');
      const sound = slide?.querySelector('[data-reference-sound]');
      if (pause) { pause.innerHTML = video.paused ? '▶' : '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M5 4h3v12H5zM12 4h3v12h-3z"/></svg>'; pause.setAttribute('aria-label', video.paused ? root.dataset.playLabel : root.dataset.pauseLabel); }
      if (sound) { sound.textContent = video.muted ? '♪' : '♫'; sound.setAttribute('aria-label', video.muted ? root.dataset.soundLabel : root.dataset.muteLabel); sound.setAttribute('aria-pressed', String(!video.muted)); }
    };
    const update = () => {
      frame = 0;
      const active = current();
      visible = isVisible(active);
      if (active !== previousVideo) { stoppedByUser = false; previousVideo = active; }
      videos().forEach(video => {
        const selected = video === active;
        const slide = video.closest('.swiper-slide');
        slide?.querySelectorAll('button').forEach(button => { button.tabIndex = selected ? 0 : -1; });
        if (!selected || !visible) stop(video);
      });
      if (!active) return;
      if (visible && active.hasAttribute('data-reference-portrait') && !reduced.matches && !stoppedByUser) {
        hydrate(active);
        if (active.paused) active.play().then(() => { delete root.dataset.playBlocked; labels(active); }).catch(() => { root.dataset.playBlocked = 'true'; labels(active); });
      }
      labels(active);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const originalCount = element.querySelectorAll('.swiper-slide').length;
    swiper = new Swiper(element, {
      init: false,
      slidesPerView: 1.2,
      spaceBetween: 16,
      freeMode: false,
      speed: reduced.matches ? 0 : 150,
      grabCursor: false,
      centeredSlides: true,
      loop: originalCount >= 5,
      initialSlide: originalCount < 5 ? Math.floor((originalCount - 1) / 2) : 0,
      slideToClickedSlide: true,
      breakpoints: {
        320: { slidesPerView: 1.75 },
        768: { slidesPerView: 3.2 },
        1280: { slidesPerView: 4.2 }
      },
      on: {
        slideChange: schedule,
        transitionEnd: schedule,
        init: schedule
      }
    });
    element.tabIndex = 0;
    element.setAttribute('role', 'region');
    element.setAttribute('aria-label', root.querySelector('.artistMedia_card_top')?.textContent.trim() || document.title);
    root.toggleAttribute('data-reduced-motion', reduced.matches);
    on(root, 'click', event => {
      const pause = event.target.closest('[data-reference-pause]');
      const sound = event.target.closest('[data-reference-sound]');
      if (!pause && !sound) { if (event.target.closest('.video-container-box')) root.toggleAttribute('data-controls-open'); return; }
      event.stopPropagation();
      const video = event.target.closest('.swiper-slide').querySelector('video');
      if (video !== current()) return;
      if (sound) { video.muted = !video.muted; labels(video); return; }
      if (video.paused) {
        stoppedByUser = false;
        hydrate(video);
        video.play().then(() => labels(video)).catch(() => { root.dataset.playBlocked = 'true'; labels(video); });
      } else { stoppedByUser = true; stop(video); labels(video); }
    });
    on(element, 'keydown', event => {
      if (event.target !== element) return;
      if (event.key === 'ArrowRight') { event.preventDefault(); swiper.slideNext(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); swiper.slidePrev(); }
    });
    on(root, 'play', event => {
      const video = event.target;
      if (video.tagName !== 'VIDEO') return;
      if (video !== current() || !isVisible(video)) stop(video);
      else videos().forEach(other => { if (other !== video) stop(other); });
      labels(video);
    }, { capture: true });
    on(window, 'scroll', schedule, { passive: true });
    on(window, 'resize', schedule, { passive: true });
    on(document, 'visibilitychange', () => { if (document.hidden) videos().forEach(stop); else schedule(); });
    on(reduced, 'change', () => { root.toggleAttribute('data-reduced-motion', reduced.matches); swiper.params.speed = reduced.matches ? 0 : 150; if (reduced.matches) videos().forEach(stop); schedule(); });
    const observer = new IntersectionObserver(schedule, { threshold: [0, .25, .5, .75, 1] });
    observer.observe(element);
    instances.set(root, () => { abort.abort(); observer.disconnect(); cancelAnimationFrame(frame); videos().forEach(stop); swiper.destroy(true, true); instances.delete(root); });
    swiper.init();
    schedule();
  }
  const scan = scope => scope.querySelectorAll('[data-reference-reel]').forEach(init);
  window.PhoenixReferenceReels = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  window.addEventListener('load', () => scan(document), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-reference-reel]').forEach(root => instances.get(root)?.()));
})();
